import * as yup from 'yup';

export const subscribeSchema = yup.object().shape({
  email: yup
    .string()
    .trim()
    .required('Email is required')
    .matches(
      /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
      'Invalid email format (check for special characters like ? or #)'
    )
    .email('Invalid email address'),
});